import { format_presale_days } from "@/helpers/presale";

/**
 * «زمان آماده‌سازی محصول: N روز» برای پیش‌فروش.
 * ساعتِ نامعتبر یا صفر چیزی رندر نمی‌کند، پس بدون شرط اضافه می‌شود.
 */
const PresaleLeadTime = ({ hours, icon = null, label = "زمان آماده‌سازی محصول", className = "", textClassName = "" }) => {
    const days = format_presale_days(hours);
    if (!days) return null;

    return (
        <div className={`flex items-center gap-1 ${className}`}>
            {icon}
            <span className={textClassName}>{label}: {days}</span>
        </div>
    );
};

export default PresaleLeadTime;
